import React, { useState } from 'react';
import { Navigate, useParams } from 'react-router';

import { faLayerPlus } from '@fortawesome/pro-light-svg-icons/faLayerPlus';

import { IconLink } from '../../../../common/components/IconLink';
import ElementLocators from '../../../../common/ElementLocators';
import { EvidenceDrawer } from '../../../detail/drawer/evidence/EvidenceDrawer';

const OrderEvidences = () => {
  const copy = 'Order more evidences';

  // For controlling the EvidenceDrawer component
  const [isOpen, setIsOpen] = useState(false);
  const openDrawer = () => {
    setIsOpen(true);
  };

  const { id } = useParams<{ id: string }>();
  if (id === undefined) {
    return <Navigate to={{ pathname: '/' }} />;
  }

  return (
    <>
      <EvidenceDrawer
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        applicationId={id}
      />
      <IconLink
        onClick={openDrawer}
        icon={faLayerPlus}
        copy={copy}
        locator={ElementLocators.APPROVE_DECISION_LINK}
      />
    </>
  );
};

export default OrderEvidences;
